import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Pagination } from "react-bootstrap";
import { API_END_POINT } from "../config";
import { JWT_SECRET_TOKEN } from "../config";
const jwt = require("jsonwebtoken");
import Cookie from "js-cookie";
const token = Cookie.get("waffle_world_access_token");

export default class SpecialOffers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      specialOffers: [],
      activePage: 1,
      pages: 1,
      q: "",
      loading: false,
      responseMessage: "Loading SpecialOffers...",
    };
    // API_END_POINT = 'https://admin.saaditrips.com';
  }
  componentWillMount() {
    this.fetchSpecialOffers();
  }

  fetchSpecialOffers = () => {
    this.setState({ loading: true });
    axios.get(`${API_END_POINT}/api/items/specialOffer`).then((response) => {
      let SortedArray = response.data.object;
      SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
      this.setState({
        specialOffers: SortedArray,
        pages: Math.ceil(response.data.length / 10),
        loading: false,
        responseMessage: "No SpecialOffers Found",
      });
    });
  };

  deleteItem(specialOfferId, index) {
    const requestParams = {
      itemId: specialOfferId,
    };
    if (confirm("Are you sure you want to delete this specialOffer?")) {
      const tokenx = jwt.sign({ payload: requestParams }, JWT_SECRET_TOKEN, {
        expiresIn: "1h",
      });
      axios
        .delete(`${API_END_POINT}/api/items/delete`, {
          data: requestParams,
          headers: { "auth-token": tokenx },
        })
        .then((response) => {
          const specialOffers = this.state.specialOffers.slice();
          specialOffers.splice(index, 1);
          this.setState({ specialOffers });
          window.alert(response.data.msg);
        });
    }
  }

  handleSelect(page) {
    axios.get(`/api/area?offset=${(page - 1) * 10}`).then((response) => {
      this.setState({
        areas: response.data.items,
        activePage: page,
      });
    });
  }

  handleSearch() {
    const { q } = this.state;
    if (q.length) {
      this.setState({
        loading: true,
        specialOffers: [],
        responseMessage: "Loading Special Offers...",
      });
      // if(q === "") {
      //   this.fetchSpecialOffers();
      // } else {
      axios
        .get(`${API_END_POINT}/api/items/specialoffer/search`, {
          params: { searchWord: this.state.q },
          headers: { "auth-token": token },
        })
        .then((response) => {
          let SortedArray = response.data.searchedItems;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            specialOffers: SortedArray,
            loading: false,
            responseMessage: "No Special Offers Found...",
          });
        });
    }
  }

  render() {
    // console.log(this.state);
    const { loading, specialOffers, responseMessage } = this.state;
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row space-1">
            <div className="col-sm-4">
              <h3>Liste der Angebote</h3>
            </div>
            <div className="col-sm-4">
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  name="search"
                  placeholder="Enter keyword"
                  value={this.state.q}
                  // onChange={(event) => this.setState({ q: event.target.value })}
                  onChange={(event) =>
                    this.setState({ q: event.target.value }, () => {
                      if (this.state.q === "") {
                        this.fetchSpecialOffers();
                      }
                    })
                  }
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      this.handleSearch();
                    }
                  }}
                />
                <span className="input-group-btn">
                  <button
                    type="button"
                    onClick={() => this.handleSearch()}
                    className="btn btn-info search-btn"
                  >
                    Suche
                  </button>
                </span>
              </div>
            </div>

            <div className="col-sm-4 pull-right mobile-space">
              <Link to="/special-offers/specialOffer_form">
                <button type="button" className="btn btn-success">
                  Neues Angebot erstellen
                </button>
              </Link>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Nr. #</th>
                  <th>Bild</th>
                  <th>Name</th>
                  <th>Preis</th>
                  <th>Angebots Preis</th>
                  <th>Beschreibung</th>
                </tr>
              </thead>
              <tbody>
                {this.state.specialOffers &&
                this.state.specialOffers.length >= 1 ? (
                  this.state.specialOffers.map((specialOffer, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {/* <td>{specialOffer._id}</td> */}
                      <td>
                        {
                          <img
                            style={{ height: "50px", width: "50px" }}
                            src={specialOffer.image && specialOffer.image}
                          />
                        }
                      </td>
                      <td>{specialOffer.name}</td>
                      <td>{specialOffer.price} €</td>
                      <td>{specialOffer.specialOfferPrice} €</td>
                      <td>{specialOffer.description}</td>
                      <td>
                        <Link
                          to={`/special-offers/edit_specialOffer/${specialOffer._id}`}
                        >
                          <span
                            className="fa fa-edit"
                            aria-hidden="true"
                          ></span>
                        </Link>
                      </td>
                      <td>
                        <span
                          className="fa fa-trash"
                          style={{ cursor: "pointer" }}
                          aria-hidden="true"
                          onClick={() =>
                            this.deleteItem(specialOffer._id, index)
                          }
                        ></span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      {responseMessage}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="text-center">
            <Pagination prev next items={this.state.pages} activePage={this.state.activePage} onSelect={this.handleSelect.bind(this)}> </Pagination>
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/SpecialOffers.jsx